var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',_vm._b({attrs:{"placeholder":_vm.placeholder,"track-by":"id","options":_vm.options,"select-label":"","deselect-label":""},on:{"select":_vm.onSelect,"remove":_vm.onRemove}},'multiselect',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }